module.exports = __webpack_public_path__ + "static/media/mysql.92c9bab3.png";